/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { loadingPayoutConfig } from '../../config/loading.config';
export interface ILoadingPayoutPluginMethods extends IPluginMethodMap {
  getLoadingPayoutSync(args?: any): any;
}

export class LoadingPayoutPlugin implements IAgentPlugin {
  readonly methods: ILoadingPayoutPluginMethods;

  constructor() {
    this.methods = {
      getLoadingPayoutSync: this.getLoadingPayoutSync.bind(this),
    };
  }

  getLoadingPayoutSync(args?: any) {
    return {
      loading: loadingPayoutConfig,
    };
  }
}
